/**
 * Whisper書き起こし結果を学年相応の表記に変換するユーティリティ
 * - カタカナ → ひらがな
 * - 小学3年生以上の漢字 → ひらがな（ルックアップテーブルで変換）
 * - 小学1・2年生の漢字はそのまま表示
 */

// 小学1年生の漢字（80字）
const GRADE1 =
  '一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六';

// 小学2年生の漢字（160字）
const GRADE2 =
  '引羽雲園遠何科夏家歌画回会海絵外角活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話';

// 1・2年生の漢字セット（これは表示したままにする）
// eslint-disable-next-line no-unused-vars
const GRADE1_2 = new Set([...GRADE1, ...GRADE2]);

/**
 * 小学3年生以上の漢字を含む語句 → ひらがな変換テーブル
 * 長い語句を先に並べる（前から順に一致させるため）
 */
const WORD_TABLE = [
  // たんぽぽのちえ
  ['倒れている', 'たおれている'],
  ['倒れました', 'たおれました'],
  ['倒れます', 'たおれます'],
  ['倒れて', 'たおれて'],
  ['倒れる', 'たおれる'],
  ['倒れ', 'たおれ'],
  ['地面に', 'じめんに'],
  ['地面', 'じめん'],
  ['知恵', 'ちえ'],
  ['綿毛', 'わたげ'],
  ['咲いています', 'さいています'],
  ['咲きました', 'さきました'],
  ['咲いて', 'さいて'],
  ['咲いた', 'さいた'],
  ['咲き', 'さき'],
  ['咲く', 'さく'],
  ['飛ばします', 'とばします'],
  ['飛ばして', 'とばして'],
  ['飛んで', 'とんで'],
  ['飛びます', 'とびます'],
  ['飛ぶ', 'とぶ'],
  ['飛び', 'とび'],
  ['飛ば', 'とば'],
  ['しぼんで', 'しぼんで'],
  ['はいつくばります', 'はいつくばります'],
  ['はいつくばり', 'はいつくばり'],

  // スイミー
  ['泳いでいます', 'およいでいます'],
  ['泳いで', 'およいで'],
  ['泳ぎます', 'およぎます'],
  ['泳ぎ', 'およぎ'],
  ['泳ぐ', 'およぐ'],
  ['深い', 'ふかい'],
  ['深く', 'ふかく'],
  ['速い', 'はやい'],
  ['速く', 'はやく'],
  ['暗い', 'くらい'],
  ['暗く', 'くらく'],
  ['沖', 'おき'],
  ['岩陰', 'いわかげ'],
  ['逃げました', 'にげました'],
  ['逃げて', 'にげて'],
  ['逃げる', 'にげる'],
  ['逃げ', 'にげ'],

  // お手紙
  ['郵便屋', 'ゆうびんや'],
  ['郵便', 'ゆうびん'],
  ['配達', 'はいたつ'],
  ['幸せ', 'しあわせ'],
  ['悲しい', 'かなしい'],
  ['悲しく', 'かなしく'],

  // 共通・よく使われる語
  ['落ちています', 'おちています'],
  ['落ちました', 'おちました'],
  ['落ちて', 'おちて'],
  ['落ちる', 'おちる'],
  ['落ち', 'おち'],
  ['落とし', 'おとし'],
  ['落とす', 'おとす'],
  ['流れています', 'ながれています'],
  ['流れて', 'ながれて'],
  ['流れる', 'ながれる'],
  ['流れ', 'ながれ'],
  ['流し', 'ながし'],
  ['進んでいます', 'すすんでいます'],
  ['進んで', 'すすんで'],
  ['進みます', 'すすみます'],
  ['進む', 'すすむ'],
  ['進み', 'すすみ'],
  ['持っています', 'もっています'],
  ['持って', 'もって'],
  ['持ちます', 'もちます'],
  ['持つ', 'もつ'],
  ['持ち', 'もち'],
  ['感じます', 'かんじます'],
  ['感じて', 'かんじて'],
  ['感じる', 'かんじる'],
  ['感じ', 'かんじ'],
  ['運んで', 'はこんで'],
  ['運びます', 'はこびます'],
  ['運ぶ', 'はこぶ'],
  ['重い', 'おもい'],
  ['重く', 'おもく'],
  ['軽い', 'かるい'],
  ['軽く', 'かるく'],
  ['待っています', 'まっています'],
  ['待って', 'まって'],
  ['待ちます', 'まちます'],
  ['待つ', 'まつ'],
  ['配って', 'くばって'],
  ['配ります', 'くばります'],
  ['植えて', 'うえて'],
  ['植える', 'うえる'],
  ['調べて', 'しらべて'],
  ['調べる', 'しらべる'],
  ['整列', 'せいれつ'],
  ['整え', 'ととのえ'],

  // もしもしかめよ（grade 0）
  ['世界のうちに', 'せかいのうちに'],
  ['世界', 'せかい'],
  ['お前ほど', 'おまえほど'],
  ['お前', 'おまえ'],
  ['歩みの', 'あゆみの'],
  ['歩み', 'あゆみ'],
  ['遅いものはない', 'おそいものはない'],
  ['遅いのか', 'おそいのか'],
  ['遅い', 'おそい'],
  ['遅く', 'おそく'],
  ['遅さ', 'おそさ'],

  // どんぐりころころ（grade 0）
  ['お池に', 'おいけに'],
  ['池に', 'いけに'],
  ['池', 'いけ'],
  ['大変', 'たいへん'],

  // ももたろう（grade 1）
  ['洗濯をしていると', 'せんたくをしていると'],
  ['洗濯', 'せんたく'],
  ['鬼が島へ', 'おにがしまへ'],
  ['鬼が島', 'おにがしま'],
  ['鬼たちは', 'おにたちは'],
  ['鬼たちに', 'おにたちに'],
  ['鬼たちが', 'おにたちが'],
  ['鬼たちと', 'おにたちと'],
  ['鬼たち', 'おにたち'],
  ['鬼を', 'おにを'],
  ['鬼に', 'おにに'],
  ['鬼と', 'おにと'],
  ['鬼', 'おに'],
  ['猿と', 'さると'],
  ['猿に', 'さるに'],
  ['猿が', 'さるが'],
  ['猿', 'さる'],
  ['雉を', 'きじを'],
  ['雉が', 'きじが'],
  ['雉', 'きじ'],
  ['仲間にして', 'なかまにして'],
  ['仲間と', 'なかまと'],
  ['仲間', 'なかま'],
  ['向かいました', 'むかいました'],
  ['向かって', 'むかって'],
  ['向かい', 'むかい'],
  ['宝物を', 'たからものを'],
  ['宝物', 'たからもの'],
  ['無事に', 'ぶじに'],
  ['無事', 'ぶじ'],

  // おむすびころりん（grade 1）
  ['優しい', 'やさしい'],
  ['優しく', 'やさしく'],
  ['穴に', 'あなに'],
  ['穴の', 'あなの'],
  ['穴へ', 'あなへ'],
  ['穴', 'あな'],
  ['覗いてみると', 'のぞいてみると'],
  ['覗いて', 'のぞいて'],
  ['覗く', 'のぞく'],
  ['踊っていました', 'おどっていました'],
  ['踊って', 'おどって'],
  ['踊ると', 'おどると'],
  ['踊りに', 'おどりに'],
  ['踊る', 'おどる'],
  ['踊り', 'おどり'],
  ['お礼の', 'おれいの'],
  ['お礼', 'おれい'],
  ['渡しました', 'わたしました'],
  ['渡して', 'わたして'],
  ['渡す', 'わたす'],

  // さるかにがっせん（grade 1）
  ['一生懸命', 'いっしょうけんめい'],
  ['育てました', 'そだてました'],
  ['育てて', 'そだてて'],
  ['育てる', 'そだてる'],
  ['育て', 'そだて'],
  ['実が', 'みが'],
  ['実を', 'みを'],

  // こぶとりじいさん（grade 1）
  ['喜びました', 'よろこびました'],
  ['喜んで', 'よろこんで'],
  ['喜び', 'よろこび'],
  ['取ってくれました', 'とってくれました'],
  ['取ってくれ', 'とってくれ'],
  ['取って', 'とって'],
];

/**
 * カタカナ → ひらがな
 */
function toHiragana(text) {
  return text.replace(/[ァ-ヶ]/g, (c) =>
    String.fromCharCode(c.charCodeAt(0) - 0x60)
  );
}

/**
 * Whisper書き起こし結果を学年相応の表記に変換する
 * @param {string} transcript Whisperの書き起こし結果
 * @returns {string} 変換後のテキスト
 */
export function convertForDisplay(transcript) {
  if (!transcript) return transcript;

  // 1. カタカナ → ひらがな
  let text = toHiragana(transcript);

  // 2. 3年生以上の漢字熟語 → ひらがな（長い順に変換）
  for (const [from, to] of WORD_TABLE) {
    text = text.split(from).join(to);
  }

  // 3. 幾何学記号・特殊記号・置換文字を除去（Whisperが聞き取れなかった部分に混入することがある）
  //    U+FFFD : Unicode置換文字（◆に見える）
  //    U+25A0-25FF: Geometric Shapes (◆ ■ □ など)
  //    U+2600-27BF: Miscellaneous Symbols / Dingbats
  text = text.replace(/[�■-◿☀-➿]/g, '');

  // 4. 残った漢字を1文字ずつチェック
  //    1・2年生の漢字以外はひらがなに変換できないため、そのまま表示
  //    （文脈によって読みが変わるため単独変換は不正確になる）
  return text;
}
